<template>
  <div>
    Zhitniakov Software Solutions LTD,<br>
    Georgiou A' 13, Stala Court off. 3,<br>
    Germasogeia 4040,<br>
    Limassol, Cyprus
  </div>
</template>

<script>
export default {
  name: "CompanyAddress"
}
</script>

<style scoped>

</style>
